import { Form, Formik } from "formik";
import * as Yup from "yup";
import { FiGrid } from "react-icons/fi";
import { Input } from "../../../components/Input";
import { Modal, ModalButton } from "../../../components/Modal";
import { SelectSearch } from "../../../components/SelectSearch";
import { api } from "../../../services/api";

interface ModalAddSectorProps {
  setModalAddSector(showModal: boolean): void;
}

interface Sector {
  newSector_name: string;
  newSector_costumer_id: string;
}

const schema = Yup.object().shape({
  newSector_name: Yup.string().required("Nome do setor é obrigatório"),
});

export function ModalAddSector({ setModalAddSector }: ModalAddSectorProps) {
  const initialValues: Sector = {
    newSector_name: "",
    newSector_costumer_id: "",
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={schema}
      onSubmit={() => {
        // Submit handled by button onClick
      }}
    >
      {({ errors, setFieldValue, setFieldTouched, values }) => (
        <Modal
          isOpen
          onClose={() => setModalAddSector(false)}
          title="Novo Setor"
          icon={<FiGrid size={24} />}
          variant="primary"
          footer={
            <>
              <ModalButton
                variant="cancel"
                onClick={() => setModalAddSector(false)}
              >
                Cancelar
              </ModalButton>
              <ModalButton
                variant="success"
                onClick={async () => {
                  if (!values.newSector_name) return;
                  await api.post("/sectors", {
                    name: values.newSector_name,
                    costumer_id: values.newSector_costumer_id,
                  });
                  setModalAddSector(false);
                }}
              >
                Salvar
              </ModalButton>
            </>
          }
        >
          <Form>
            <div className="space-y-4">
              <div>
                <span className="block text-sm font-medium text-gray-700 mb-1">
                  Nome do Setor
                </span>
                <Input
                  type="text"
                  name="newSector_name"
                  placeholder="Digite o nome do setor"
                  error={errors.newSector_name}
                  className="h-[52px] px-4 w-full rounded-lg text-[#7FA5B2] bg-white border border-gray-200 focus:border-[#0085BD] focus:ring-1 focus:ring-[#0085BD]"
                />
              </div>
              <div>
                <span className="block text-sm font-medium text-gray-700 mb-1">
                  Cliente
                </span>
                <SelectSearch
                  name="newSector_costumer_id"
                  placeholder="Digite o nome do cliente..."
                  onChange={value => {
                    setFieldValue("newSector_costumer_id", value);
                    setFieldTouched("newSector_costumer_id", true);
                  }}
                />
              </div>
            </div>
          </Form>
        </Modal>
      )}
    </Formik>
  );
}
